/*
 * @Author: whb
 * @Date: 2023-01-10 18:59:18
 * @LastEditors: whb
 * @LastEditTime: 2023-01-12 19:25:35
 * @Description: 隐私&条款
 */
import { axiosUtils } from "./utils";
console.log("process env--", process.env.NODE_ENV);
const API_HOST =
  window.location.hostname === "vr.starmakerstudios.com"
    ? "https://m.starmakerstudios.com"
    : "https://m-test.starmakerstudios.com";
// 获取翻译
export const getTrans = (data) => {
  return axiosUtils(`${API_HOST}/setting/trans`, data, {
    method: "post",
    formData: true,
  });
};
/**
 * 获取文档内容
 * @param {string} content_type
 * @param {string} app
 * @param {string} language
 * @param {string} region
 */
export const getDoc = (data) => {
  return axiosUtils(`${API_HOST}/setting/get-doc`, data);
};
